import { PropsWithChildren } from "react";
import clsx from "clsx";

import styles from "./BusinessSSOTypeSelect.module.css";

export const BusinessSSOTypeSelectWrapper = ({ children }: PropsWithChildren) => {
  return (
    <>
      <h3 className={clsx("lds-h4", styles.businessSSOTypeSelectLabel)}>SSO Provider Type</h3>
      <div className={styles.businessSSOTypeSelectWrapper}>{children}</div>
    </>
  );
};
